import React, { Component, Fragment } from 'react';
import { Field, FormSpy } from 'react-final-form';
import { Form } from 'antd';
import { path } from 'ramda';
import Translate from 'react-translate-component';

import {
    metroCell,
} from 'constants/dictionaries';
import { wrapCellFormItem } from 'constants/formItemLayout';
import { METRO_REQUEST_TYPES, METRO_REQUEST_TYPES_CURRENT, METRO_REQUEST_CURRENT, METRO_REQUEST_NEW } from 'constants/metro';
import { renderCellItem } from 'helpers/metroHelpers';
import { SelectLoadComponent } from 'components/common/form/Select';
import Input from 'components/common/form/Input';
import RadioButtons from 'components/common/form/RadioButtons';
import ListenerField from 'components/common/form/ListenerField';

export default class TypeFields extends Component {
    renderCellField = (departmentCode, disabled) => (
        <Field
            name='cellId'
            component={SelectLoadComponent}
            label={{ content: 'metro.request.positionCode' }}
            loadName={metroCell}
            loadParams={{ DepartmentID: departmentCode }}
            nameRender={renderCellItem}
            onChange={(...attrs) => {
                this.props.getChangeField('positionCode', ['data', 'positionId'])(...attrs);
                this.props.getChangeField('positionCodeForRestore', ['data', 'positionId'])(...attrs);

                const [, options] = attrs;
                const hasWorker = path(['data', 'worker'], options);

                if (hasWorker) {
                    this.props.getChangeField('displacedEmployee', ['data', 'worker_name'])(...attrs);
                    this.props.getChangeField('displacedEmployeeCode', ['data', 'worker'])(...attrs);
                    this.props.getChangeField('displacedEmployeePid', ['data', 'worker_pid'])(...attrs);
                } else {
                    this.props.getChangeField('displacedEmployee')(null);
                    this.props.getChangeField('displacedEmployeeCode')(null);
                    this.props.getChangeField('displacedEmployeePid')(null);
                }
            }}
            disabled={disabled}
        />
    )

    render() {
        const { clearPosition, cellId, departmentCode, oldPosition, disabled, isApproval, isCNB, isACO } = this.props;

        return <Fragment>
            { !departmentCode ? null :
                <FormSpy>
                    { ({ values }) =>
                        <Field
                            name='requestType'
                            component={RadioButtons}
                            options={values.requestType === METRO_REQUEST_NEW ? METRO_REQUEST_TYPES : METRO_REQUEST_TYPES_CURRENT}
                            label={{ content: 'metro.request.requestType' }}
                            onChange={clearPosition}
                            radioTranslate='metro.request.types'
                            disabled={disabled || values.requestType === METRO_REQUEST_CURRENT}
                        />
                    }
                </FormSpy>
            }

            <ListenerField listenFieldName={['displacedEmployee', 'requestType']}>
                { ({ requestType, displacedEmployee }) => !departmentCode || !requestType ? null :
                    <Fragment>
                        { (requestType === METRO_REQUEST_CURRENT || disabled && cellId) ? (
                            <Fragment>
                                { this.renderCellField(departmentCode, disabled) }
                                { oldPosition && isApproval && (isCNB || isACO) && (
                                    <Input
                                        input={{ value: oldPosition }}
                                        label={{ content: 'metro.request.positionCatalogNumber' }}
                                        disabled={true}
                                    />
                                )}
                                { !!cellId && (
                                    displacedEmployee ? (
                                        <Field
                                            name='displacedEmployee'
                                            component={Input}
                                            label={{ content: 'metro.request.displacedEmployee' }}
                                            disabled={true}
                                        />
                                    ) : (
                                        <Fragment>
                                            <Form.Item wrapperCol={wrapCellFormItem}>
                                                <Translate content='metro.request.positionIsVacant' />
                                            </Form.Item>
                                        </Fragment>
                                    )
                                )}
                            </Fragment>
                        ) : null}
                    </Fragment>
                }
            </ListenerField>
        </Fragment>;
    }
}
